type Props = {
  children: React.ReactNode;
};

const BackgroundWrapper = ({ children }: Props) => {
  return (
    <div className='relative flex items-center justify-center bg-cover bg-center'>
      <div className='absolute hidden h-full w-full bg-[url("/svg/RainbowWaveSecondary.svg")] bg-cover bg-no-repeat lg:block z-0 scale-150' />
      {children}
    </div>
  );
};

export default BackgroundWrapper;
